import customer from "../../../../api/customer";
import policy from "../../../../api/policy";
import keyValueStoreApi from "../../../../api/key_value_store";

const setFamily = (state, family) => {
  state.commit("SET_FAMILY", family);
};

const getFamily = (state, customerId) => {
  customer.findFamily(customerId, [
    "main.object_count",
    "partner.object_count",
    "children.object_count",
  ]).then((res) => {
    state.commit("SET_FAMILY", res.data);
    state.commit("SET_FAMILY_ARRAY");
  });
};

const getPolicyPageForCustomer = ({ commit, state }, customerId) => {
  commit("SET_LOADING", true);
  const include = [
    "policies.product_labels",
    "policies.agency",
    "active_packages.agency.departments.employees",
    "active_packages.policies.product_labels",
    "inactive_packages.agency.departments.employees",
    "inactive_packages.policies.product_labels",
  ];
  policy.getPolicyPage(customerId, state.filter, include).then((res) => {
    commit("SET_LOADING", false);
    commit("SET_ACTIVE_PACKAGES", { packages: res.data.active_packages.data, customerId });
    commit("SET_POLICIES", { policies: res.data.policies.data, customerId });
    commit("SET_INACTIVE_PACKAGES", { packages: res.data.inactive_packages.data, customerId });
  });
};
const saveDisplayState = ({ state }) => {
  keyValueStoreApi.set("policy_page", state.filter);
};
const getDisplayState = ({ commit, dispatch, state }) => {
  commit("SET_FILTER_LOADED", false);
  keyValueStoreApi.has("policy_page").then((hasDisplayState) => {
    if (hasDisplayState) {
      keyValueStoreApi.get("policy_page").then((response) => {
        commit("SET_FILTER_LOADED", true);
        commit("SET_FILTER", response);
      });
    } else {
      keyValueStoreApi.set("policy_page", state.filter).then(() => {
        commit("SET_FILTER_LOADED", true);
      });
    }
  }).catch(() => {
    dispatch("saveDisplayState");
  });
};
export default {
  getDisplayState,
  saveDisplayState,
  getPolicyPageForCustomer,
  setFamily,
  getFamily,
};
